module.exports = __webpack_public_path__ + "static/media/fig_31.1ae5cdb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_31.jpg
// module id = 672
// module chunks = 0